export default __webpack_public_path__ + "static/media/Training-hover.5c36b21d.svg";